import { Injectable, Inject } from '@angular/core';
import { StoreService } from '@morningstar/shared/base/base-service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { HttpClient } from '@angular/common/http';
import { environment } from '@morningstar/shared/environment';
import { InvoiceSelectors } from './invoice.selectors';

@Injectable({
  providedIn: 'root'
})
export class InvoiceService extends StoreService {

  constructor(snackbar: MatSnackBar,
              @Inject('API_BASE_URL') baseUrl: string,
              httpClient: HttpClient) {
    super(httpClient, baseUrl, snackbar);
  }

  getCutoffDate() {
    const endpoint = environment.api.invoice.processing.cutoffDate;

    this.read<boolean>(InvoiceSelectors.cutoffDate, endpoint, 'cutoff date')
        .subscribe();
  }
}
